import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { handleErrorApi } from "../../helpers/randoms";
import { formatSpError } from "../../helpers/extraFunctions";
import { finishSpinner, startSpinner } from "../ui/spinner";
import CosegurosService from "../../services/CosegurosService";
import { PRACTICA_EMPADRONAMIENTO, TIPO_TURNO } from "../../utils/constants";

export const resetBuscadorPracticas = () => {
  return {
    type: types.coseguroResetBuscadorPracticas,
  };
};

export const resetPracticas = () => {
  return {
    type: types.coseguroVaciarPracticas,
    payload: [],
  };
};

export const resetValorizaciones = () => {
  return {
    type: types.coseguroResetValorizaciones,
  };
};

export const getPracticaTexto = (texto, autorizacion, internacionDomiciliaria, gestionAutorizacion = false) => async (dispatch) => {
  try {
    
    const response = autorizacion || gestionAutorizacion ?
    await CosegurosService.getBuscardorPracticasAutorizacionTexto(texto, internacionDomiciliaria)
    : await CosegurosService.getBuscardorPracticasCoseguroTexto(texto);

    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.coseguroGetBuscadorPracticasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.coseguroGetBuscadorPracticasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los códigos de practicas de coseguros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getPracticasCoseguros = (data, idTipoTurnoSol, turnoSeleccionado) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = turnoSeleccionado?.especialidad?.practicasDemanda
      ? await CosegurosService.getPracticasLaboDemanda(turnoSeleccionado.idAgenda)
      : await CosegurosService.getPracticas(data);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.coseguroGetPracticasSuccess,
        payload: idTipoTurnoSol === TIPO_TURNO.VIRTUAL
          ? body.filter(s => s.idCodNom === PRACTICA_EMPADRONAMIENTO.ID_COD_NOM)
          : body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.coseguroGetPracticasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las practicas de coseguros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getPracticasCosegurosExterno = (data, idTipoTurnoSol) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await CosegurosService.getPracticasExterno(data);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.coseguroGetPracticasSuccess,
        payload: idTipoTurnoSol === TIPO_TURNO.VIRTUAL
          ? body.filter(s => s.idCodNom === PRACTICA_EMPADRONAMIENTO.ID_COD_NOM)
          : body,
      });
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    dispatch({ type: types.coseguroGetPracticasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer las practicas de coseguros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getPracticaLiquidaciones = (texto, esLineaCodigoLiq, idEfectorFacturacion, idTipoNomenclador) => async (dispatch) => {
  try {
    
    const response = await CosegurosService.getPracticaLiquidaciones(texto, esLineaCodigoLiq, idEfectorFacturacion, idTipoNomenclador)

    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.coseguroGetBuscadorPracticasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    dispatch({ type: types.coseguroGetBuscadorPracticasError });
    handleErrorApi(
      dispatch,
      error,
      "Error al traer los códigos de practicas de liquidaciones",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const addPractica = (data) => async (dispatch, getState) => {
  try {
    const response = await CosegurosService.addPractica(data);
    const body = await response.json();
    if (response.ok) {
      const { practicas } = getState().coseguros;
      const practica = body;
      const newPracticas = [...practicas, practica];
      dispatch({
        type: types.coseguroAddPractica,
        payload: newPracticas,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al agregar la practica de coseguros",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const postPracticasCoseguros =
  (data, setEsPantallaFormulario, setOpenConfirmar) => async (dispatch) => {
    try {
      const response = await CosegurosService.postPracticas(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta("Practicas agregadas correctamente", "success"));
        // setEsPantallaFormulario(false);
        dispatch(
          getValorizacionesCoseguro(
            data.idAgenda,
            setEsPantallaFormulario,
            setOpenConfirmar
          )
        );
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postPracticasCtaCteCoseguros =
  (data, setEsPantallaFormulario, setOpenConfirmar, closeModalCoseguro, setOpenPracticasHandler, 
    getValorizacion = true, changeStepperTurnos, closeModalPracticas) =>
  async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await CosegurosService.postPracticas(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta("Practicas agregadas correctamente", "success"));
        if(getValorizacion){
          if (closeModalCoseguro && data.agregada) {
            closeModalCoseguro();
            setOpenPracticasHandler(false);
          } else {
            dispatch(
              getValorizacionesCtaCoseguro(
                data.idAgenda,
                setEsPantallaFormulario,
                setOpenConfirmar
              )
            );
          }
        } else {
          changeStepperTurnos&& changeStepperTurnos();
          closeModalPracticas&& closeModalPracticas();
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        formatSpError(error),
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const postPracticasCtaCteCosegurosExterno =
  (data, setEsPantallaFormulario, setOpenConfirmar, closeModalCoseguro, setOpenPracticasHandler,
    getValorizacion = true, changeStepperTurnos, closeModalPracticas
  ) =>
  async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await CosegurosService.postPracticas(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(startAlerta("Practicas agregadas correctamente", "success"));
        if(getValorizacion){
          if (closeModalCoseguro && data.agregada) {
            closeModalCoseguro();
            setOpenPracticasHandler(false);
          } else {
            dispatch(
              getValorizacionesCtaCoseguroExterno(
                data.idAgenda,
                setEsPantallaFormulario,
                setOpenConfirmar,
                data.idObraSocial
              )
            );
          }
        } else {
          changeStepperTurnos&& changeStepperTurnos();
          closeModalPracticas&& closeModalPracticas();
        }
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        formatSpError(error),
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const getValorizacionesCoseguro =
  (idAgenda, setEsPantallaFormulario, setOpenConfirmar) => async (dispatch) => {
    try {
      const response = await CosegurosService.getValorizaciones(idAgenda);
      const body = await response.json();
      if (response.ok) {
        if (body.saltarFormularioPago) {
          setOpenConfirmar(true);
        } else {
          dispatch({
            type: types.coseguroGetValorizacionesSuccess,
            payload: body,
          });
          setEsPantallaFormulario(false);
        }
      } else {
        throw body;
      }
    } catch (error) {
      dispatch({ type: types.coseguroGetValorizacionesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const getValorizacionesCtaCoseguro =
  (idAgenda, setEsPantallaFormulario, setOpenConfirmar) => async (dispatch) => {
    try {
      const response = await CosegurosService.getValorizacionesCtaCte(idAgenda);
      const body = await response.json();
      if (response.ok) {
        if (body.saltarFormularioPago) {
          setOpenConfirmar(true);
        } else {
          dispatch({
            type: types.coseguroGetValorizacionesSuccess,
            payload: body,
          });
          setEsPantallaFormulario(false);          
        }
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.coseguroGetValorizacionesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const getValorizacionesCtaCoseguroExterno =
  (idAgenda, setEsPantallaFormulario, setOpenConfirmar, idObraSocial ) => async (dispatch) => {
    try {
      const response = await CosegurosService.getValorizacionesCtaCteExterno(idAgenda, idObraSocial);
      const body = await response.json();
      if (response.ok) {
        if (body.saltarFormularioPago) {
          setOpenConfirmar(true);
          dispatch(finishSpinner());
        } else {
          dispatch({
            type: types.coseguroGetValorizacionesSuccess,
            payload: body,
          });
          setEsPantallaFormulario(false);
          dispatch(finishSpinner());
        }
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      dispatch({ type: types.coseguroGetValorizacionesError });
      handleErrorApi(
        dispatch,
        error,
        "Error al enviar las practicas de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postTurnoImporteCoseguro =
  (data, closeModalCoseguro, confirmarAsistenciaTurno, idAgenda, impago) =>
  async (dispatch) => {
    try {
      const response = await CosegurosService.postTurnoImporte(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(confirmarAsistenciaTurno(idAgenda, true, !impago));
        closeModalCoseguro();
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        "Error al confirmar el pago de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postFacturaTurnoCoseguro =
  (data, closeModalCoseguro, confirmarAsistenciaTurno, idAgenda, impago, 
    closeModalDemandaLaboratorio, fecha, idProfesional) =>
  async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await CosegurosService.postFacturaTurno(data);
      const body = await response.json();
      if (response.ok) {
        closeModalCoseguro();
        dispatch(finishSpinner());
        dispatch(confirmarAsistenciaTurno(idAgenda, true, !impago, 
          closeModalDemandaLaboratorio, fecha, idProfesional)
        );
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al confirmar el pago de coseguros",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

export const postExentarTurno = (idAgenda, idAfiliado) => async (dispatch) => {
  try {
    const response = await CosegurosService.postExentarTurno({
      idAgenda,
      idAfiliado,
    });
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.agendaExentarPagoTurnoSuccess,
        payload: idAgenda,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al exentar el turno",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const postAnularComprobantePorCancelacion =
  (data, closeModalDevolucionMonto, confirmarAsistenciaTurno, idAgenda) =>
  async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response =
        await CosegurosService.postAnularComprobantePorCancelacion(data);
      const body = await response.json();
      if (response.ok) {
        dispatch(confirmarAsistenciaTurno(idAgenda, false));
        closeModalDevolucionMonto();
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al procesar devolución de monto",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };
